// extracted by mini-css-extract-plugin
export var askAiIcon = "_og-9";
export var container = "_og-0";
export var groupSeparator = "_og-a";
export var highlight = "_og-4";
export var resultIcon = "_og-5";
export var resultItem = "_og-7";
export var resultSubtitle = "_og-3";
export var resultTitle = "_og-2";
export var resultsList = "_og-1";
export var searchGroup = "_og-6";
export var selected = "_og-8";